/*
 * PROD-7828 A-22 W2 — Payment details review: query params and request bodies, pinned to
 * teacher_payment_details_ops_enums (request_fields_read/required) by request_fields.test.js.
 */
import { trim_reason } from '../needs_attention/params';

export const PENDING_PAGE_SIZE = 50;
export const AWAITING_PAGE_SIZE = 100;

// after_id: the previous page's next_after_id (0 = first page; the server reads 0 as "from the start").
export const pending_params = (after_id, limit = PENDING_PAGE_SIZE) => ({
  after_id: after_id || 0,
  limit
});

export const view_params = (detail_uuid) => ({ detail_uuid });

// POST, so the number never sits in a URL, a log line or a cache.
export const reveal_body = (detail_uuid) => ({ detail_uuid });

export const approve_body = (detail_uuid, confirm_shared_account) => ({
  detail_uuid,
  confirm_shared_account: confirm_shared_account === true
});

export const reject_body = (detail_uuid, reason) => ({ detail_uuid, reason: trim_reason(reason) });

// since_month '' = the server's default (the payouts cutover month); the query builder drops it.
export const awaiting_params = (since_month, after_teacher_id, limit = AWAITING_PAGE_SIZE) => ({
  since_month: since_month || '',
  after_teacher_id: after_teacher_id || 0,
  limit
});
